export default "__VITE_ASSET__5aeea50a__"